/** Marketing presentation only; never an entitlement or checkout authority. */
export const HOMEPAGE_PLANS = {
  free: { questions: 3, monthlyPrice: 0 },
  premium: { questions: 50, monthlyPrice: 9.99 },
} as const;

/** Local scripted example: no AI request, billing call or saved student data. */
export const HOMEPAGE_DEMO = {
  question: "3x + 7 = 22",
  steps: [
    { key: "subtract", work: "3x + 7 − 7 = 22 − 7" },
    { key: "simplify", work: "3x = 15" },
    { key: "divide", work: "3x ÷ 3 = 15 ÷ 3" },
    { key: "answer", work: "x = 5" },
  ],
  answer: 5,
} as const;